import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'

const resource = createResource({
  en: {
    mainTitle: 'SHAREHOLDER',
    subTitle1: 'Neuroncredit Pte. Ltd.',
    desc1: `This company is a company established under the laws of the Republic of Singapore with Registration No. 201716089E which is engaged in information technology consulting. This company is under the control of Advance Intelligence Group Limited.`,
    subTitle2: 'PT Karya Widura Utama',
    desc2: `This company is a company established under the laws of the Republic of Indonesia based on Deed of Establishment No. 46 dated August 28, 2017 made before Notary Emmyra Fauzia Kariana, S.H., M.Kn. As approved by the Minister of Law and Human Rights based on Decree No. AHU-0038539.AH.01.01.YEAR 2017 dated September 4, 2017. This company is engaged in the field of, among others, consulting activities.`,
  },
  id: {
    mainTitle: 'PEMEGANG SAHAM',
    subTitle1: 'Neuroncredit Pte. Ltd.',
    desc1: `Perusahaan ini adalah suatu perusahaan yang didirikan berdasarkan hukum negara Republik Singapura dengan No. Registrasi 201716089E yang bergerak dibidang konsultansi teknologi informasi. Perusahaan ini berada di bawah kendali Advance Intelligence Group Limited.`,
    subTitle2: 'PT Karya Widura Utama',
    desc2: `Perusahaan ini adalah suatu perusahaan yang didirikan berdasarkan hukum negara Republik Indonesia berdasarkan Akta Pendirian No.46 tanggal 28 Agustus 2017 yang dibuat dihadapan Notaris Emmyra Fauzia Kariana, S.H., M.Kn. Sebagaimana telah disahkan oleh Menteri Hukum dan Hak Asasi Manusia berdasarkan Surat Keputusan No. AHU-0038539.AH.01.01.TAHUN 2017 tanggal 4 September 2017. Perusahaan ini bergerak di bidang, salah satunya, aktivitas konsultasi.`,
  },
})

const ShareholderHook = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const FeatureList = [
    {
      subtitle: t('subTitle1'),
      desc: t('desc1'),
    },
    {
      subtitle: t('subTitle2'),
      desc: t('desc2'),
    },
  ]
  return (
    <Introduce>
      <div className="main-title">{t('mainTitle')}</div>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {FeatureList.map((item, index) => (
            <div key={index} className="item">
              <div className="text-group">
                <div className="subtitle">{item.subtitle}</div>
                <div className="desc">{item.desc}</div>
              </div>
            </div>
          ))}
      </div>
    </Introduce>
  )
}

export default ShareholderHook

const Introduce = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 48px auto 0;
    text-align: center;
    width: 100%;
    .main-title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      padding-bottom: 24px;
    }
    .items {
      .item {
        margin: 0 auto;
        text-align: left;
        width: 272px;
        .subtitle {
          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #1cc812;
          line-height: 21px;
          margin: 8px auto 16px;
        }
        .desc {
          font-size: 14px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 20px;
          margin-bottom: 30px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 0px 150px 72px;
    text-align: center;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    .main-title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      padding-bottom: 48px;
    }
    .items {
      display: grid;
      grid-template-rows: repeat(2, 1fr);
      .item {
        text-align: left;
        .text-group {
          .subtitle {
            font-size: 18px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #1cc812;
            line-height: 24px;
            width: 90%;
            margin: 8px 0;
          }
          .desc {
            font-size: 14px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #757575;
            line-height: 24px;
          }
        }
      }
    }
  }
`
